import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, createVNode as _createVNode, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "col-12 card" }
const _hoisted_4 = { class: "row mx-2 my-5" }
const _hoisted_5 = { class: "col-sm-12 col-md-8" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-12 card" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = { class: "row quote-approved" }
const _hoisted_10 = { class: "col-12 text-center p-2" }
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "row quote-rejected" }
const _hoisted_13 = { class: "col-12 text-center p-2" }
const _hoisted_14 = { class: "text-center mt-3" }
const _hoisted_15 = { class: "h2" }
const _hoisted_16 = { class: "applicant-contact mb-0 w-50 m-auto" }
const _hoisted_17 = { class: "applicant-contact mb-0 w-50 m-auto" }
const _hoisted_18 = { class: "applicant-contact mb-5 w-50 m-auto" }
const _hoisted_19 = { class: "mx-5" }
const _hoisted_20 = { class: "row" }
const _hoisted_21 = { class: "col-sm-12 col-md-4" }
const _hoisted_22 = { class: "mb-0" }
const _hoisted_23 = {
  key: 0,
  class: "mb-0"
}
const _hoisted_24 = { class: "mb-0" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { class: "col-sm-12 col-md-4" }
const _hoisted_27 = { class: "col-sm-12 col-md-4" }
const _hoisted_28 = { class: "row mb-4" }
const _hoisted_29 = { class: "col-12 mb-3" }
const _hoisted_30 = { key: 0 }
const _hoisted_31 = { class: "me-4 float-start" }
const _hoisted_32 = ["src"]
const _hoisted_33 = { class: "scenario-name" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 0 }
const _hoisted_36 = { key: 1 }
const _hoisted_37 = {
  id: "quote-builder",
  class: "col-sm-12 col-md-4"
}
const _hoisted_38 = { class: "row mb-5" }
const _hoisted_39 = { class: "col-12" }
const _hoisted_40 = { class: "row mb-5" }
const _hoisted_41 = { class: "col-12" }
const _hoisted_42 = { key: 0 }
const _hoisted_43 = ["onUpdate:modelValue", "disabled"]
const _hoisted_44 = { key: 1 }
const _hoisted_45 = ["onUpdate:modelValue", "disabled"]
const _hoisted_46 = { class: "session-numbers" }
const _hoisted_47 = { class: "row mb-4" }
const _hoisted_48 = { class: "col-12" }
const _hoisted_49 = { align: "right" }
const _hoisted_50 = { align: "right" }
const _hoisted_51 = { align: "right" }
const _hoisted_52 = { class: "row mb-5" }
const _hoisted_53 = { class: "col-12" }
const _hoisted_54 = ["disabled"]
const _hoisted_55 = { class: "row mb-5" }
const _hoisted_56 = { class: "col-12" }
const _hoisted_57 = ["disabled"]
const _hoisted_58 = { class: "row mb-5" }
const _hoisted_59 = { class: "col-12" }
const _hoisted_60 = ["disabled"]
const _hoisted_61 = { key: 0 }
const _hoisted_62 = { class: "row" }
const _hoisted_63 = { class: "col-12 mb-4" }
const _hoisted_64 = { class: "row" }
const _hoisted_65 = { class: "col-12 mb-4" }
const _hoisted_66 = { class: "row" }
const _hoisted_67 = { class: "col-12" }
const _hoisted_68 = { key: 1 }
const _hoisted_69 = { class: "alert alert-danger" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_currency_input = _resolveComponent("currency-input")!
  const _component_loading = _resolveComponent("loading")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.loading && !_ctx.err_msg && _ctx.quote)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", _hoisted_6, [
                    _createElementVNode("div", _hoisted_7, [
                      (_ctx.is_approved)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                            _createElementVNode("div", _hoisted_9, [
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("strong", null, "Quote sent to applicant on " + _toDisplayString(_ctx.moment(_ctx.pending_partner.approved_at).format('MM/DD/YYYY')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      (_ctx.is_rejected)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                            _createElementVNode("div", _hoisted_12, [
                              _createElementVNode("div", _hoisted_13, [
                                _createElementVNode("strong", null, "Applicant rejected on " + _toDisplayString(_ctx.moment(_ctx.pending_partner.rejected_at).format('MM/DD/YYYY')), 1)
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true),
                      _createElementVNode("div", _hoisted_14, [
                        _createElementVNode("p", _hoisted_15, _toDisplayString(_ctx.quote.user.name), 1),
                        _createElementVNode("p", _hoisted_16, _toDisplayString(_ctx.quote.user.email), 1),
                        _createElementVNode("p", _hoisted_17, _toDisplayString(_ctx.quote.user.mobile_number), 1),
                        _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.quote.user.job_title), 1),
                        _cache[10] || (_cache[10] = _createElementVNode("hr", { class: "hr-dark" }, null, -1))
                      ]),
                      _createElementVNode("div", _hoisted_19, [
                        _createElementVNode("div", _hoisted_20, [
                          _createElementVNode("div", _hoisted_21, [
                            _createElementVNode("h4", null, _toDisplayString(_ctx.quote.user.company_name), 1),
                            _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.quote.user.address_1), 1),
                            (_ctx.quote.user.address_2 !== null)
                              ? (_openBlock(), _createElementBlock("p", _hoisted_23, _toDisplayString(_ctx.quote.user.address_2), 1))
                              : _createCommentVNode("", true),
                            _createElementVNode("p", _hoisted_24, [
                              _createTextVNode(_toDisplayString(_ctx.quote.user.city), 1),
                              (_ctx.quote.user.state !== null)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_25, ", " + _toDisplayString(_ctx.quote.user.state.short_name), 1))
                                : _createCommentVNode("", true),
                              _createTextVNode(" " + _toDisplayString(_ctx.quote.user.zip), 1)
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_26, [
                            _cache[11] || (_cache[11] = _createElementVNode("h4", null, "Target Start Date", -1)),
                            _createElementVNode("p", null, _toDisplayString(_ctx.moment(_ctx.start_date).format('MM/DD/YYYY')), 1)
                          ]),
                          _createElementVNode("div", _hoisted_27, [
                            _cache[12] || (_cache[12] = _createElementVNode("h4", null, "Submitted on", -1)),
                            _createElementVNode("p", null, _toDisplayString(_ctx.moment(_ctx.quote.created_at).format('MM/DD/YYYY')), 1)
                          ])
                        ]),
                        _cache[14] || (_cache[14] = _createElementVNode("hr", { class: "hr-dark" }, null, -1)),
                        _createElementVNode("div", _hoisted_28, [
                          _createElementVNode("div", _hoisted_29, [
                            _createElementVNode("h4", null, [
                              _cache[13] || (_cache[13] = _createTextVNode("Requested Scenario")),
                              (_ctx.selected_scenarios.length)
                                ? (_openBlock(), _createElementBlock("span", _hoisted_30, "s"))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selected_scenarios, (option) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: option.id,
                              class: "col-sm-12 col-md-6"
                            }, [
                              _createElementVNode("div", _hoisted_31, [
                                _createElementVNode("img", {
                                  class: "rounded-circle",
                                  width: "100",
                                  src: option.scenario.patient_image.location
                                }, null, 8, _hoisted_32)
                              ]),
                              _createElementVNode("h4", _hoisted_33, _toDisplayString(option.scenario.patient_name), 1),
                              _createElementVNode("div", null, _toDisplayString(option.scenario.title), 1),
                              _createElementVNode("small", null, "Requested Number of Sessions: " + _toDisplayString(option.scenario_count), 1),
                              (option.scenario_count_invoice > 0)
                                ? (_openBlock(), _createElementBlock("p", _hoisted_34, [
                                    _createElementVNode("small", null, [
                                      (_ctx.is_approved)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_35, "Invoiced"))
                                        : (_openBlock(), _createElementBlock("span", _hoisted_36, "Proposed")),
                                      _createTextVNode(" Number of Sessions: " + _toDisplayString(option.scenario_count_invoice), 1)
                                    ])
                                  ]))
                                : _createCommentVNode("", true)
                            ]))
                          }), 128))
                        ])
                      ])
                    ])
                  ])
                ]),
                _createElementVNode("div", _hoisted_37, [
                  _cache[35] || (_cache[35] = _createElementVNode("div", { class: "row" }, [
                    _createElementVNode("div", { class: "col-12" }, [
                      _createElementVNode("p", { class: "mb-0" }, [
                        _createElementVNode("strong", null, "Quote Builder")
                      ]),
                      _createElementVNode("p", null, [
                        _createElementVNode("small", null, "Automatically generate and send quote")
                      ])
                    ])
                  ], -1)),
                  _createElementVNode("div", _hoisted_38, [
                    _createElementVNode("div", _hoisted_39, [
                      _cache[15] || (_cache[15] = _createElementVNode("label", {
                        for: "session_rate",
                        class: "mb-0"
                      }, "Session Rate", -1)),
                      _cache[16] || (_cache[16] = _createElementVNode("div", { class: "text-small" }, "Amount charged to partner per session. Amount should reflect all associated fees per session.", -1)),
                      _createVNode(_component_currency_input, {
                        modelValue: _ctx.session_rate,
                        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.session_rate) = $event)),
                        maxlength: 3,
                        size: 8,
                        onChange: _ctx.calculateTotal,
                        disabled: _ctx.is_approved || _ctx.is_rejected
                      }, null, 8, ["modelValue", "onChange", "disabled"])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _createElementVNode("div", _hoisted_41, [
                      _cache[18] || (_cache[18] = _createElementVNode("label", {
                        for: "number_of_sessions",
                        class: "mb-0"
                      }, "Number of Sessions", -1)),
                      _cache[19] || (_cache[19] = _createElementVNode("p", null, [
                        _createElementVNode("small", null, "Co-brand will be limited to this number of sessions.")
                      ], -1)),
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.scenarios, (option) => {
                        return (_openBlock(), _createElementBlock("div", {
                          class: "session-numbers",
                          key: option.id
                        }, [
                          (option.scenario_count_invoice > 0)
                            ? (_openBlock(), _createElementBlock("span", _hoisted_42, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "onUpdate:modelValue": ($event: any) => ((option.scenario_count_invoice) = $event),
                                  maxlength: "3",
                                  min: "0",
                                  required: "",
                                  onChange: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.calculateTotalSessions && _ctx.calculateTotalSessions(...args))),
                                  disabled: _ctx.is_approved || _ctx.is_rejected
                                }, null, 40, _hoisted_43), [
                                  [_vModelText, option.scenario_count_invoice]
                                ])
                              ]))
                            : (_openBlock(), _createElementBlock("span", _hoisted_44, [
                                _withDirectives(_createElementVNode("input", {
                                  type: "number",
                                  "onUpdate:modelValue": ($event: any) => ((option.scenario_count) = $event),
                                  maxlength: "3",
                                  min: "0",
                                  required: "",
                                  onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.calculateTotalSessions && _ctx.calculateTotalSessions(...args))),
                                  disabled: _ctx.is_approved || _ctx.is_rejected
                                }, null, 40, _hoisted_45), [
                                  [_vModelText, option.scenario_count]
                                ])
                              ])),
                          _createTextVNode(" " + _toDisplayString(option.patient_name), 1)
                        ]))
                      }), 128)),
                      _createElementVNode("div", _hoisted_46, [
                        _withDirectives(_createElementVNode("input", {
                          type: "number",
                          min: "1",
                          name: "number_of_sessions",
                          "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.quote_number_of_sessions) = $event)),
                          disabled: true
                        }, null, 512), [
                          [_vModelText, _ctx.quote_number_of_sessions]
                        ]),
                        _cache[17] || (_cache[17] = _createTextVNode(" Total "))
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_47, [
                    _createElementVNode("div", _hoisted_48, [
                      _cache[23] || (_cache[23] = _createElementVNode("label", {
                        for: "payment_amount",
                        class: "mb-0"
                      }, "Program Cost", -1)),
                      _cache[24] || (_cache[24] = _createElementVNode("div", { class: "text-small" }, "This is the total amount that partner will be required to pay in order to execute contract. Calculated based on session rate times number of sessions plus the processing fee.", -1)),
                      _createElementVNode("table", null, [
                        _createElementVNode("tbody", null, [
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_49, "$" + _toDisplayString(_ctx.calculateSessions()) + " ", 1),
                            _cache[20] || (_cache[20] = _createElementVNode("td", null, "Session Rate", -1))
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_50, "$" + _toDisplayString(_ctx.calculateProcessingFee()) + " ", 1),
                            _cache[21] || (_cache[21] = _createElementVNode("td", null, "Proccessing Fee", -1))
                          ]),
                          _createElementVNode("tr", null, [
                            _createElementVNode("td", _hoisted_51, [
                              _createElementVNode("strong", null, "$" + _toDisplayString((_ctx.processingFee + _ctx.subTotal).toFixed(2)) + " ", 1)
                            ]),
                            _cache[22] || (_cache[22] = _createElementVNode("td", null, [
                              _createElementVNode("strong", null, "Total")
                            ], -1))
                          ])
                        ])
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_52, [
                    _createElementVNode("div", _hoisted_53, [
                      _cache[25] || (_cache[25] = _createElementVNode("label", {
                        for: "agreement_duration",
                        class: "mb-0"
                      }, "Number of Months", -1)),
                      _cache[26] || (_cache[26] = _createElementVNode("p", null, [
                        _createElementVNode("small", null, "The term of the agreement in months.")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "number",
                        min: "1",
                        max: "60",
                        name: "agreement_duration",
                        "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.agreement_duration) = $event)),
                        disabled: _ctx.is_approved || _ctx.is_rejected
                      }, null, 8, _hoisted_54), [
                        [_vModelText, _ctx.agreement_duration]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_55, [
                    _createElementVNode("div", _hoisted_56, [
                      _cache[27] || (_cache[27] = _createElementVNode("p", { class: "mb-0" }, [
                        _createElementVNode("label", { for: "brand_title" }, "Brand Title")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        maxlength: "255",
                        size: "30",
                        name: "brand_title",
                        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.brand_title) = $event)),
                        disabled: _ctx.is_approved || _ctx.is_rejected
                      }, null, 8, _hoisted_57), [
                        [_vModelText, _ctx.brand_title]
                      ])
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_58, [
                    _createElementVNode("div", _hoisted_59, [
                      _cache[28] || (_cache[28] = _createElementVNode("label", {
                        for: "brand_subdomain",
                        class: "mb-0"
                      }, "Brand Subdomain", -1)),
                      _cache[29] || (_cache[29] = _createElementVNode("div", { class: "text-small" }, [
                        _createTextVNode("First subdomain of URL for co-brand."),
                        _createElementVNode("br"),
                        _createTextVNode(" E.G., partner.simclusive.com, co-brand.simclusive.com, etc.")
                      ], -1)),
                      _withDirectives(_createElementVNode("input", {
                        type: "text",
                        maxlength: "50",
                        size: "30",
                        name: "brand_subdomain",
                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.brand_subdomain) = $event)),
                        disabled: _ctx.is_approved || _ctx.is_rejected
                      }, null, 8, _hoisted_60), [
                        [_vModelText, _ctx.brand_subdomain]
                      ])
                    ])
                  ]),
                  (!_ctx.is_approved && !_ctx.is_rejected)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_61, [
                        _createElementVNode("div", _hoisted_62, [
                          _createElementVNode("div", _hoisted_63, [
                            _createElementVNode("button", {
                              class: "btn btn-md btn-primary w-50",
                              onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.saveQuote && _ctx.saveQuote(...args)))
                            }, "Save Quote"),
                            _cache[30] || (_cache[30] = _createElementVNode("br", null, null, -1)),
                            _cache[31] || (_cache[31] = _createElementVNode("small", null, "Allows for updating of quote before finalizing", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_64, [
                          _createElementVNode("div", _hoisted_65, [
                            _createElementVNode("button", {
                              class: "btn btn-md btn-primary w-50",
                              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.approvePartner && _ctx.approvePartner(...args)))
                            }, "Approve Request"),
                            _cache[32] || (_cache[32] = _createElementVNode("br", null, null, -1)),
                            _cache[33] || (_cache[33] = _createElementVNode("small", null, "Partner will be notified by email to sign and submit payment", -1))
                          ])
                        ]),
                        _createElementVNode("div", _hoisted_66, [
                          _createElementVNode("div", _hoisted_67, [
                            _createElementVNode("button", {
                              class: "btn btn-md btn-danger w-50",
                              onClick: _cache[9] || (_cache[9] = 
//@ts-ignore
(...args) => (_ctx.rejectPartner && _ctx.rejectPartner(...args)))
                            }, "Reject Request"),
                            _cache[34] || (_cache[34] = _createElementVNode("p", null, [
                              _createElementVNode("small", null, "Applicant will be notified by email of rejection decision")
                            ], -1))
                          ])
                        ])
                      ]))
                    : _createCommentVNode("", true)
                ])
              ])
            ])
          ])
        ]))
      : (!_ctx.loading && _ctx.err_msg)
        ? (_openBlock(), _createElementBlock("div", _hoisted_68, [
            _createElementVNode("div", _hoisted_69, _toDisplayString(_ctx.err_msg), 1)
          ]))
        : _createCommentVNode("", true),
    _createVNode(_component_loading, {
      active: _ctx.loading,
      "is-full-page": true
    }, null, 8, ["active"])
  ], 64))
}